import * as React from 'react';
import { releaseStepDetailsContainerModuleStyle, antGrey, titleStyle } from '../styles/globalStyles';
import Space from 'antd/lib/space';
import Text from 'antd/lib/typography/Text';
import AutomatedByRunwayIcon from '../AutomatedByRunwayIcon';
import MarkdownComponent from '../HOCs/Markdown';

interface CIBuildDiffSummaryModuleProps {
    summary: string;
}

const CIBuildDiffSummaryModule: React.FC<CIBuildDiffSummaryModuleProps> = ({ summary }) => {
    const titleTextStyle: React.CSSProperties = {
        ...titleStyle,
        color: antGrey.grey7,
        fontSize: 12,
    };

    return (
        <div style={{ ...releaseStepDetailsContainerModuleStyle, backgroundColor: antGrey.grey2, overflow: 'hidden' }}>
            <Space direction="vertical" size={12}>
                <Space>
                    <AutomatedByRunwayIcon />
                    <Text style={titleTextStyle}>Diff Summary</Text>
                </Space>
                <div style={{ padding: 8 }}>
                    <MarkdownComponent source={summary} />
                </div>
            </Space>
        </div>
    );
};

export default CIBuildDiffSummaryModule;
